/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const feedbackNodes = Array.from(document.querySelectorAll('.hub-feedback'));
if (feedbackNodes.length) {
    import(/* webpackChunkName: "HubFeedback" */ './components/HubFeedback').then(({ default: HubFeedback }) => {
        feedbackNodes.forEach((node) => render(<HubFeedback {...parseDataToProps(node.dataset)} />, node));
    });
}
